import { render, staticRenderFns } from "./InternetConnection.vue?vue&type=template&id=b84ebd8c&scoped=true"
import script from "./InternetConnection.vue?vue&type=script&lang=ts"
export * from "./InternetConnection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84ebd8c",
  null
  
)

export default component.exports